/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "./bootstrap";

import Vue from "vue";
import Vuex from 'vuex';
import VueRouter from "vue-router";
import Vuetify from "vuetify";
import VueMeta from 'vue-meta';
import VueResizeText from 'vue-resize-text';
import moment from 'moment-timezone';
import {
    extendMoment
} from 'moment-range';
import firebase from 'firebase';
import VueDragscroll from 'vue-dragscroll'
import VueGTag from "vue-gtag";
import VueShepherd from 'vue-shepherd';
import Ads from 'vue-google-adsense'
import Hotjar from 'vue-hotjar';

/**
 * Load Vue Configs (Store, Router)
 */
import store from './store';
import router from './router';

const DEFAULT_TITLE = 'Home';
const TITLE_POSTFIX = ' | DirecTV';
router.afterEach((to, from) => {
    console.log("Router after each");
    var new_title;
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {


        if (to.meta.title) {
            switch (to.meta.title) {
                case "Season":
                    new_title = to.params.schedule + " Schedule";
                    break;
                case "Events":

                    new_title = capitalizeFirstLetter(to.params.sport);
                    new_title = new_title + ((!!~['all', 'custom'].indexOf(to.params.sport)) ? " Sports" : "");
                    new_title = new_title + " - " + capitalizeFirstLetter(to.params.league);
                    new_title = new_title + ((!!~['all', 'custom'].indexOf(to.params.league)) ? " Leagues" : "");
                    break;
                default:
                    new_title = to.meta.title;
                    break;
            }

        } else {
            new_title = DEFAULT_TITLE;
        }

        document.title = new_title + TITLE_POSTFIX;
    });
});
/**
 * Load Main Component
 */
import App from "./components/App";

/**
 * Register plugins
 */
window.VueMeta = VueMeta;
window.Vuex = Vuex;
window.VueRouter = VueRouter;
window.Vuetify = Vuetify;

//Moment.js init
window.moment = extendMoment(moment);
moment().format();

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})

Vue.use(Vuetify);

Vue.use(VueResizeText);

Vue.use(VueDragscroll)

Vue.use(VueGTag, {
    config: {
        id: "UA-163276051-1"
    },
    includes: [{
        id: 'GTM-TTQ8S2C'
    }, ]
}, router);

Vue.use(VueShepherd);
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)

Vue.use(Hotjar, {
    id: process.env.MIX_HOTJAR_ID
});

import ApiService from './api/api.service';
import _ from "lodash";
ApiService.init();

/**
 * Register Mixins
 */
Vue.mixin({
    data() {
        return {
            showBetaFeatures: process.env.MIX_BETA_FEATURES === "true",
        };
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    methods: {
        toTitleCase(str) {
            return str.replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        },
        handle_function_call(function_name) {
            this[function_name]()
        },
        checkPasswordStrength(password) {

            // Test for:
            // 1. Uppercase Alphabet
            // 2. Lowercase Alphabet
            // 3. Numeric Digits
            // 4. Special Characters
            // 5. Length

            //Regular Expressions
            let regex = new Array();
            regex.push("[A-Z]"); //For Uppercase Alphabet
            regex.push("[a-z]"); //For Lowercase Alphabet
            regex.push("[A-Z]"); //For Numeric Digits
            regex.push("[$@$!%*#?&]"); //For Special Characters

            let passed = 0;

            //Validation for each Regular Expression
            for (let i = 0; i < regex.length; i++) {
                if ((new RegExp(regex[i])).test(password)) {
                    passed++;
                }
            }

            //Validation for Length of Password
            if (passed > 2 && password.length >= 8) {
                passed++;
            }

            return {
                strength: passed / 5 * 100,
                tests: [{
                        passed: new RegExp("[a-z]").test(password),
                        message: "At least one lowercase letter"
                    },
                    {
                        passed: new RegExp("[A-Z]").test(password),
                        message: "At least one capital letter"
                    },
                    {
                        passed: new RegExp("[0-9]").test(password),
                        message: "At least one number"
                    },
                    {
                        passed: new RegExp("[$@$!%*#?&]").test(password),
                        message: "At least one special character"
                    },
                    {
                        passed: password.length >= 8,
                        message: "Be at least 8 characters"
                    }
                ]
            };
        },
        searchArrayByKey(key, list, field = 'id', seeking = 'object') {
            for (var i = 0; i < list.length; i++) {
                if (list[i][field] == key) {
                    if (seeking == 'object') {
                        return list[i];
                    } else if (seeking == 'name') {
                        return list[i].name;
                    } else {
                        return i;
                    }

                }
            }
        },
        scrollToBottom() {
            this.$nextTick(() => {
                setTimeout(() => {
                    window.scrollTo(0, document.body.scrollHeight);
                }, 500);
            });
        },

    }
});
/**
 * Initialize VueJS
 */
const app = new Vue({
    el: "#app",
    store,
    router,
    vuetify: new Vuetify({
        theme: {
            light: true,
            themes: {
                light: {
                    primary: "#0057b8",
                    lightBlue: "#1976D2",
                    darkBlue: "#2B5680",
                    blue: "#0057b8",
                    red: "#990000",
                    orange: "#FF6600",
                    green: "#009688",
                }
            }
        },
    }),
    render: h => h(App)
});
